/*
Controller: SecretCode

Operations:
  checkUniqueSecretCode
*/
var Api = require('../config')
var SecretCodeUniqueDef = require('../definitions/SecretCodeUnique')

var SecretCode = (function () {
  /*
  Operation: checkUniqueSecretCode
  Check if secret code applied to promotion is unique
  Parameters:

  Responses:
    HTTP 200: Secret code uniqueness Check performed
    HTTP 403: Operation not permitted
  */
  function checkUniqueSecretCodeSecretCode (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        SecretCodeUniqueDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/secretcode/checkUnique'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['checkUniqueSecretCode'] = checkUniqueSecretCodeSecretCode
  return ret
})()

module.exports = SecretCode
